/**
 * The legal documents the app asks people to accept, and the version of each.
 *
 * The WORDS of a document live in its own page component (PrivacyPage.vue,
 * TermsAndConditions.vue). This file is the one place that says which version
 * those words are, so the text someone reads and the version we record against
 * their name cannot drift apart.
 *
 * To change a document:
 *   1. edit its page component,
 *   2. bump `version` here to the date of the change (YYYY-MM-DD),
 *   3. that is all. Everyone who accepted an older version is asked again, and
 *      the AI features pause for them until they do. The rest of the app keeps
 *      working.
 *
 * The version is also what is sent to the server at sign-up and at
 * re-acceptance, and what the server stores. The server is a ledger: it records
 * the version it is told was shown. That means a browser running a stale cached
 * build could record an older version than the one deployed, which is the one
 * known weakness of keeping the text in the frontend; it is recorded honestly
 * either way, which is what matters.
 */

export const LEGAL_DOCUMENTS = {
    privacy: {
        key: 'privacy',
        version: '2026-10-29',
        effective: 'October 29, 2026',
        title: 'Privacy Policy',
        route: '/privacy-policy',
    },
    terms: {
        key: 'terms',
        version: '2026-10-29',
        effective: 'October 29, 2026',
        title: 'Terms and Conditions',
        route: '/terms-conditions',
    },
};

export const LEGAL_DOCUMENT_KEYS = Object.keys(LEGAL_DOCUMENTS);

/** The version of one document, or null if there is no such document. */
export const currentVersion = (key) => LEGAL_DOCUMENTS[key]?.version ?? null;

/** What the sign-up form sends with the rest of the registration. */
export const signupAcceptance = () => ({
    accepted_privacy_version: currentVersion('privacy'),
    accepted_terms_version: currentVersion('terms'),
});

/** What the re-acceptance banner sends. */
export const acceptancePayload = () => ({
    acceptances: LEGAL_DOCUMENT_KEYS.map((key) => ({
        document: key,
        version: currentVersion(key),
    })),
});
